import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';

/**
 * Twilio legacy name.
 * For Agora, treat a track as "switched off" when it is not visually enabled (muted/disabled).
 */
export default function useIsTrackSwitchedOff(track: any): boolean {
  const enabled = useIsTrackEnabled(track);
  return !enabled;
}
